import { CSSProperties } from 'react';

export const bannerContainer: CSSProperties = {
  marginTop: '10px',
  width: 'calc(100% - 40px)',
  background: '#efefec',
  height: '80px',
  borderRadius: '10px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '0 15px',
  boxSizing: 'border-box'
};

export const iconContainer: CSSProperties = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center'
};

export const tonIcon: CSSProperties = {
  width: '45px',
  height: '45px',
  borderRadius: '23px',
  background: '#000'
};

export const diamondIcon: CSSProperties = {
  width: '45px',
  height: '45px',
  borderRadius: '23px',
  marginLeft: '-14px',
  background: 'orange'
};

export const diamondShape: CSSProperties = {
  marginTop: '-7px'
};

export const textContainer: CSSProperties = {
  flex: 1,
  margin: '0 15px',
  overflow: 'hidden'
};

export const text: CSSProperties = {
  fontSize: '14px',
  textAlign: 'left',
  display: 'block',
  wordBreak: 'break-word',
  lineHeight: '1.2'
};

export const arrowContainer: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%'
};
